import { ShelfLifeEntry } from './shelfLifeTypes';

export const staplesEntries: ShelfLifeEntry[] = [
  { keywords: ['bread', 'white bread', 'wheat bread', 'sourdough'], pantry: 7, fridge: 14, freezer: 90 },
  { keywords: ['tortilla', 'tortillas', 'wrap', 'wraps'], pantry: 7, fridge: 21, freezer: 180 },
  { keywords: ['bagel', 'bagels', 'english muffin'], pantry: 5, freezer: 90 },
  { keywords: ['bun', 'buns', 'roll', 'rolls', 'hamburger bun'], pantry: 5, freezer: 90 },
  { keywords: ['pita', 'naan', 'flatbread'], pantry: 5, fridge: 14, freezer: 90 },
  { keywords: ['croissant', 'pastry', 'danish', 'muffin'], pantry: 3, freezer: 90 },
  { keywords: ['cake'], fridge: 5, freezer: 120 },
  { keywords: ['pie'], fridge: 4, freezer: 120 },
  { keywords: ['ketchup'], pantry: 365, fridge: 180 },
  { keywords: ['mustard'], pantry: 365, fridge: 365 },
  { keywords: ['mayonnaise', 'mayo'], fridge: 60 },
  { keywords: ['salsa'], fridge: 14 },
  { keywords: ['soy sauce'], pantry: 730 },
  { keywords: ['hot sauce', 'sriracha', 'tabasco'], pantry: 365 },
  { keywords: ['worcestershire'], pantry: 365 },
  { keywords: ['bbq sauce', 'barbecue sauce'], pantry: 365, fridge: 120 },
  { keywords: ['salad dressing', 'ranch', 'vinaigrette'], fridge: 60 },
  { keywords: ['jam', 'jelly', 'preserves', 'marmalade'], pantry: 365, fridge: 90 },
  { keywords: ['peanut butter', 'almond butter'], pantry: 90 },
  { keywords: ['honey'], pantry: 730 },
  { keywords: ['maple syrup'], pantry: 365, fridge: 365 },
  { keywords: ['olive oil', 'vegetable oil', 'canola oil', 'coconut oil', 'cooking oil'], pantry: 365 },
  { keywords: ['vinegar', 'apple cider vinegar', 'balsamic vinegar', 'white vinegar', 'red wine vinegar'], pantry: 730 },
  { keywords: ['tomato sauce', 'marinara', 'pasta sauce', 'tomato paste'], pantry: 365, fridge: 7 },
  { keywords: ['canned beans', 'canned tomato', 'canned corn', 'canned soup', 'canned tuna', 'canned chicken'], pantry: 730 },
  { keywords: ['pasta', 'spaghetti', 'penne', 'linguine', 'fettuccine', 'macaroni', 'noodles'], pantry: 730 },
  { keywords: ['rice', 'white rice', 'brown rice', 'basmati', 'jasmine rice'], pantry: 730 },
  { keywords: ['flour', 'all-purpose flour', 'bread flour', 'wheat flour'], pantry: 240 },
  { keywords: ['sugar', 'granulated sugar', 'brown sugar', 'powdered sugar'], pantry: 730 },
  { keywords: ['cereal', 'oatmeal', 'oats', 'granola'], pantry: 180 },
  { keywords: ['crackers', 'cracker'], pantry: 180 },
  { keywords: ['chips', 'potato chips', 'tortilla chips'], pantry: 60 },
  { keywords: ['nuts', 'almonds', 'walnuts', 'pecans', 'cashews', 'peanuts'], pantry: 90, freezer: 365 },
];
